import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Eric Grossman`}</h1>
    <p>{`I'm Full Stack Developer who is passionate about building things that make people smile :)
Here's the random fact of the day...Armadillo shells are bulletproof, but please do not test this!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      